export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0h6v6a1 1 0 001 1h6v8a1 1 0 01-1 1H2a1 1 0 01-1-1V1a1 1 0 011-1zm8 0l5 5h-5V0zM6 10a1 1 0 100 2h4a1 1 0 100-2H6z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};